module.exports = __webpack_public_path__ + "media/bootstrap-icons/suit-club-fill-edb480a8.svg";